// extracted by mini-css-extract-plugin
export var label = "_ed-2";
export var slideContainer = "_ed-0";
export var slider = "_ed-1";